export { default as StatItem } from "./StatItem.svelte";
